import React from 'react';

export interface KanbanTask {
  id: string;
  title: string;
  description?: string;
  status: 'backlog' | 'in_progress' | 'review' | 'done';
  assignee?: string;
  createdAt: number;
  updatedAt: number;
  [key: string]: any;
}

export interface KanbanProposalCardProps {
  id?: string;
  title?: string;
  [key: string]: any;
}

export function KanbanProposalCard(props: KanbanProposalCardProps) {
  return null;
}

const kanbanStore = new Map<string, Map<string, KanbanTask>>();

export function getKanbanTasks(channelId: string = 'default'): Map<string, KanbanTask> {
  if (!kanbanStore.has(channelId)) {
    kanbanStore.set(channelId, new Map());
  }
  return kanbanStore.get(channelId)!;
}

export function saveKanbanTask(task: KanbanTask, channelId: string = 'default'): KanbanTask {
  const tasks = getKanbanTasks(channelId);
  tasks.set(task.id, task);
  return task;
}

export function updateKanbanTaskStatus(id: string, status: KanbanTask['status'], channelId: string = 'default'): KanbanTask {
  const tasks = getKanbanTasks(channelId);
  let task = tasks.get(id) || { id, title: id, status, createdAt: Date.now(), updatedAt: Date.now() };
  task.status = status;
  task.updatedAt = Date.now();
  tasks.set(id, task);
  return task;
}

export type ContextInspectorData = any;
export type AppPlannerTask = KanbanTask;
export const SEED_TASK_DETAILS: Record<string, any> = {};
